
import {Injectable} from "@angular/core";
import {environment} from '../../environments/environment';
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {CreateCampaignGroupSequencePayloadModel, GetAllCampaignGroupSequencePayloadModel, UpdateCampaignGroupSequencePayloadModel} from './campaign_group_sequence_interfaces';






@Injectable({providedIn: 'root'})
export class CampaignGroupSequenceService {

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {} //end constructor

  gets(endpoint: string, is_mocked: boolean = false): Observable<GetAllCampaignGroupSequencePayloadModel[]> {

    if(is_mocked) {
      return of<GetAllCampaignGroupSequencePayloadModel[]>(
        [
          {
            "campaign_group_sequence_id": "1",
            "name": "Mock Client",
            "campaign_group_sequence_parent_id": "0"

          }
        ]
      )
    } //end if is_mocked

    let url: string = `${this.url}/${endpoint}`;
    return this.http.get<GetAllCampaignGroupSequencePayloadModel[]>(url);

  } //end gets

  get(endpoint: string, is_mocked: boolean = false): Observable<GetAllCampaignGroupSequencePayloadModel> {

    // if(is_mocked) {
    //   return of<GetAllCampaignGroupSequencePayloadModel[]>([
    //     {
    //       "campaign_group_sequence_id": "1",
    //       "name": "Mock Client",
    //       "campaign_group_sequence_parent_id": "0"
    //
    //     }
    //   ]);
    // } //end if is_mocked

    let url: string = `${this.url}/${endpoint}`;
    return this.http.get<GetAllCampaignGroupSequencePayloadModel>(url);

  } //end gets

  post(endpoint: string, data: CreateCampaignGroupSequencePayloadModel){
    return this.http.post<any>(`${this.url}/${endpoint}`, data,{observe: 'response'});
  } //end post

  put(endpoint: string, data: UpdateCampaignGroupSequencePayloadModel){
    return this.http.put(`${this.url}/${endpoint}`, data,{observe: 'response'});
  } //end put

  delete(endpoint: string){
    let url = `${this.url}/${endpoint}`;
    return this.http.delete(url);
  } //end login


} //end CampaignGroupsService
